/** Parse API auth user id (`usr_42` or `42`) to numeric DB user id. */
export function parseAuthNumericUserId(id: string | number | null | undefined): number | null {
  if (id == null) return null;
  if (typeof id === 'number' && Number.isFinite(id)) return id;
  const s = String(id).trim();
  const prefixed = /^usr_(\d+)$/i.exec(s);
  if (prefixed) return Number(prefixed[1]);
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

export function isSessionStatusActive(status: string | null | undefined): boolean {
  return (status ?? '').toLowerCase() === 'active';
}

/** True when live field capture (GPS trace / session-linked submit) is allowed. */
export function isFieldCaptureLive(opts: {
  sessionApplies: boolean;
  campaignActive: boolean;
  liveGpsPaused: boolean;
  externalGnssBlocked?: boolean;
}): boolean {
  return (
    opts.sessionApplies &&
    opts.campaignActive &&
    !opts.liveGpsPaused &&
    !opts.externalGnssBlocked
  );
}
